export default "__VITE_ASSET__8baec5ae__"